import type { Job, PricingEstimate } from "./types";

export function formatCurrency(value?: number | null) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "A$0";
  return `A$${Math.round(Number(value))}`;
}

export function formatEstimateRange(input: Pick<Job, "quotedPriceMin" | "quotedPriceMax"> | PricingEstimate) {
  const range = "priceRange" in input
    ? input.priceRange
    : [input.quotedPriceMin, input.quotedPriceMax];

  return `${formatCurrency(range[0])} - ${formatCurrency(range[1])}`;
}

export function formatJobFinalPrice(job: Pick<Job, "quotedPrice" | "serviceCharge">) {
  return formatCurrency(job.serviceCharge ?? job.quotedPrice);
}

export function hasSelectedContractorPrice(job: Pick<Job, "contractorId" | "status">) {
  return Boolean(job.contractorId) || ["assigned", "awaiting_customer_confirmation", "completed", "reviewed"].includes(job.status);
}
